import React, { useEffect, useState } from 'react'
import { Button, Flex, Input, PaginationProps, Select, SelectProps, Table, TableColumnsType, Modal, Form, message } from 'antd'
import { ArrowSquareDown, Home2, SearchZoomIn1, Shop, Tag } from 'iconsax-react'
import Layout from '../../components/layouts/Layout'
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock'
import { Link } from 'react-router-dom'
import { mixPostV1 } from '../../services/mixin'
import { API_URL } from '../../env'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import './style.scss'

const customPrevNext: PaginationProps['itemRender'] = (_, type, originalElement) => {
    if (type === 'prev') {
        return (
            <Flex align='center' gap={8}>
                <ArrowLeftOutlined />
                <span>Previous</span>
            </Flex>
        )
    }
    if (type === 'next') {
        return (
            <Flex align='center' gap={8}>
                <span>Next</span>
                <ArrowRightOutlined />
            </Flex>
        )
    }
    return originalElement
}


const pencil = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 20H21" stroke="#E6E6E6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M16.5 3.49998C16.8978 3.10216 17.4374 2.87866 18 2.87866C18.2786 2.87866 18.5544 2.93353 18.8118 3.04014C19.0692 3.14674 19.303 3.303 19.5 3.49998C19.697 3.69697 19.8532 3.93082 19.9598 4.18819C20.0665 4.44556 20.1213 4.72141 20.1213 4.99998C20.1213 5.27856 20.0665 5.55441 19.9598 5.81178C19.8532 6.06915 19.697 6.303 19.5 6.49998L7 19L3 20L4 16L16.5 3.49998Z" stroke="#E6E6E6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
const trash = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#FD6A6A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
const addIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="#6FCF97" strokeWidth="2" /><path d="M12 8V16" stroke="#6FCF97" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M8 12H16" stroke="#6FCF97" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;

const ListDiscount: React.FC = () => {
    // GET STORES
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    const [stores, setStores] = useState([] as any)

    let wait = false
    const getStores = async () => {
        if (wait === true) {
            return
        }
        wait = true
        try {
            const res = await mixPostV1('/api/webAdmin/gComboStoreByOwner.php', { owner_id: user.id })
            wait = false
            if (res.status === 1) {
                const result = res.data.map((item: any) => ({
                    value: item.store_id.toString(),
                    label: item.store_name,
                }))
                setStores(result)
            }
        } catch (error) { console.log(error) }
    }
    useEffect(() => {
        getStores()

    }, [])


    // GET TYPES
    const [types, setTypes] = useState<any[]>([])
    const getTypes = async () => {
        const res = await mixPostV1('/api/webAdmin/gSettingTypeStore.php', {})
        if (res.status) {
            setTypes(res.data.map((item: any) => ({
                value: item.type_id,
                label: item.type_name,
            })))
        }
    }
    useEffect(() => {
        getTypes()
    }, [])


    // MODAL STATES
    const [addModalVisible, setAddModalVisible] = useState(false)
    const [editModalVisible, setEditModalVisible] = useState(false)
    const [deleteModalVisible, setDeleteModalVisible] = useState(false)
    const [selectedRecord, setSelectedRecord] = useState<any>(null)
    const [form] = Form.useForm()
    const [editForm] = Form.useForm()
    const [loading, setLoading] = useState(false)

    const [storeOptions, setStoreOptions] = useState<any[]>([])

    const fetchStoreOptions = async () => {
        try {
            const res = await mixPostV1('/api/webAdmin/gListStoreOwner.php', { limit: 1000, page_number: 1 })
            if (res.status === 1) {
                const options = res.data.map((item: any) => ({
                    value: item.store_id,
                    label: `${item.store_name} - ${item.owner_name}`,
                }))
                setStoreOptions(options)
            } else {
                setStoreOptions([])
            }
        } catch (error) {
            setStoreOptions([])
        }
    }

    // ADD MODAL
    const showAddModal = () => {
        setAddModalVisible(true)
        form.resetFields()
        fetchStoreOptions()
    }

    const handleAdd = async () => {
        try {
            const values = await form.validateFields()
            setLoading(true)
            const res = await mixPostV1('/api/webAdmin/createDiscountStore.php', {
                store_id: values.store_id,
                price: values.price
            })
            if (res.status === 1) {
                message.success('Discount added successfully')
                setAddModalVisible(false)
                getItems()
            } else {
                message.error(res.message || 'Failed to add discount')
            }
        } catch (error) {
            message.error('Failed to add discount')
        } finally {
            setLoading(false)
        }
    }

    const handleAddCancel = () => {
        setAddModalVisible(false)
        form.resetFields()
    }

    // EDIT MODAL
    const showEditModal = (record: any) => {
        setSelectedRecord(record)
        setEditModalVisible(true)
        editForm.setFieldsValue({
            store_id: record.store_id,
            price: record.price
        })
    }

    const handleEdit = async () => {
        try {
            const values = await editForm.validateFields()
            setLoading(true)
            const res = await mixPostV1('/api/webAdmin/editDiscountStore.php', {
                id: selectedRecord.id,
                store_id: values.store_id,
                price: values.price
            })

            if (res.status === 1) {
                message.success('Discount updated successfully')
                setEditModalVisible(false)
                getItems()
            } else {
                message.error(res.message || 'Failed to update discount')
            }
        } catch (error) {
            message.error('Failed to update discount')
        } finally {
            setLoading(false)
        }
    }

    const handleEditCancel = () => {
        setEditModalVisible(false)
        setSelectedRecord(null)
        editForm.resetFields()
    }

    // DELETE MODAL
    const showDeleteModal = (record: any) => {
        setSelectedRecord(record)
        setDeleteModalVisible(true)
    }
    const handleDelete = async () => {
        try {
            setLoading(true);
            const res = await fetch(
                `${API_URL}/api/webAdmin/deleteDiscountStore.php?store_id=${selectedRecord.store_id}`,
                {
                    method: 'DELETE',
                    headers: {
                        'accept': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    }
                }
            );
            const data = await res.json();
            if (data.status === 1) {
                message.success('Discount deleted successfully');
                setDeleteModalVisible(false);
                getItems();
            } else {
                message.error(data.message || 'Failed to delete discount');
            }
        } catch (error) {
            message.error('Failed to delete discount');
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteCancel = () => {
        setDeleteModalVisible(false)
        setSelectedRecord(null)
    }

    // TABLE COLUMNS
    const columns: TableColumnsType = [
        {
            title: '',
            key: 'actions',
            fixed: 'left',
            width: 96,
            render: (record: any) => (
                <div style={{ display: 'flex', gap: 8 }}>
                    <span style={{ cursor: 'pointer' }} onClick={() => showEditModal(record)}>{pencil}</span>
                    <span style={{ cursor: 'pointer' }} onClick={() => showDeleteModal(record)}>{trash}</span>
                </div>
            ),
        },
        {
            title: 'Owner ID',
            dataIndex: 'owner_id',
            key: 'owner_id',
        },
        {
            title: 'Owner Name',
            dataIndex: 'owner_name',
            key: 'owner_name',
        },
        {
            title: 'Store Name',
            dataIndex: 'store_name',
            key: 'store_name',
        },
        {
            title: 'Type',
            dataIndex: 'type_name',
            key: 'type_name',
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
        },
    ]

    // GET LIST
    const [items, setItems] = useState({
        list: [],
        total: 0,
    })
    const [tableLoading, setTableLoading] = useState(false)

    const [params, setParams] = useState<{
        limit: number,
        page_number: number,
        searchName?: string,
        searchType?: number,
    }>(
        {
            limit: 10,
            page_number: 1,
        }
    )

    const getItems = async () => {
        setTableLoading(true)
        try {
            const body: any = {
                limit: params.limit,
                page_number: params.page_number,
            };
            if (params.searchName) body.searchName = params.searchName;
            if (params.searchType) body.searchType = params.searchType;

            const res = await mixPostV1('/api/webAdmin/gListStoreDiscount.php', body)
            if (res.status === 1) {
                const result: any = res.data.map((item: any) => ({
                    ...item,
                }))
                setItems({
                    list: result,
                    total: res.total,
                })
            } else {
                setItems({
                    list: [],
                    total: 0,
                })
            }
            setTableLoading(false)
        } catch (error) {
            setTableLoading(false)
            setItems({
                list: [],
                total: 0,
            })
        }
    }

    useEffect(() => {
        getItems()
    }, [params])

    const onPageChange = (page: number) => {
        setParams({
            ...params,
            page_number: page,
        })
    }

    const onTableChange = (data: any) => {
        setParams({
            ...params,
            page_number: data.current,
            limit: data.pageSize,
        })
    }

    // SEARCH
    const [searchTimeout, setSearchTimeout] = useState<any>(null)
    const onSearch = (query: string) => {
        setParams({
            ...params,
            page_number: 1,
            searchName: query,
        })
    }
    const onEnter = (e: any) => {
        onSearch(e.target.value)
    }
    const onChange = (e: any) => {
        clearTimeout(searchTimeout)
        const timeout = setTimeout(() => {
            onSearch(e.target.value)
        }, 250)
        setSearchTimeout(timeout)
    }

    // TYPE CHANGE
    const onTypeChange = (value: any) => {
        setParams({
            ...params,
            page_number: 1,
            searchType: value || undefined,
        })
    }

    return (
        <>
            <Layout
                contentClassName="list-discount"
            >
                <BreadcrumbBlock
                    items={[
                        { title: <Flex align='center' gap={16}><Home2 variant="Bulk" /><Link to="/">CMD Tech</Link></Flex>, },
                        { title: 'Discount', },
                    ]}
                    title='Discount'
                    description=''
                />

                <div className="table-filter-block rps-600-flex-column">
                    <Select
                        options={types}
                        placeholder="Type"
                        popupMatchSelectWidth={false}
                        allowClear={!!params.searchType}
                        suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
                        className="rs-select w-186"
                        onChange={onTypeChange}
                    />

                    <Input
                        placeholder="Search by Store name or Owner name"
                        prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
                        className="rs-input w-349"
                        allowClear
                        onPressEnter={(e) => onEnter(e)}
                        onChange={(e) => onChange(e)}
                    />

                    <div style={{ marginLeft: 'auto' }}>
                        <Button
                            icon={addIcon}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                backgroundColor: '#1f1f1f',
                                color: '#ccc',
                                border: 'none',
                                borderRadius: 8,
                                padding: '6px 16px',
                            }}
                            onClick={showAddModal}
                        >
                            Add Discount
                        </Button>
                    </div>
                </div>

                <Table
                    columns={columns}
                    dataSource={items.list}
                    className="rs-table table-text-nowrap match-height"
                    loading={tableLoading}
                    rowKey='id'
                    scroll={{
                        x: true,
                    }}
                    pagination={{
                        pageSize: params.limit,
                        position: ['bottomCenter'],
                        showSizeChanger: true,
                        showTitle: false,
                        total: items.total,
                        itemRender: customPrevNext,
                        onChange: (e) => onPageChange(e),
                    }}
                    onChange={onTableChange}
                    locale={{ emptyText: 'No Data' }}
                />

                {/* ADD MODAL */}
                <Modal
                    title="Add New Discount"
                    open={addModalVisible}
                    onOk={handleAdd}
                    onCancel={handleAddCancel}
                    confirmLoading={loading}
                    width={600}
                    className="dark-modal"
                    footer={[
                        <Button key="cancel" onClick={handleAddCancel} className="yellow-btn-outline">Cancel</Button>,
                        <Button key="submit" type="primary" loading={loading} onClick={handleAdd} className="yellow-btn">Add</Button>,
                    ]}
                >
                    <Form
                        form={form}
                        layout="vertical"
                    >
                        <Form.Item
                            name="store_id"
                            label="Store"
                            rules={[{ required: true, message: 'Please select store' }]}
                        >
                            <Select
                                showSearch
                                placeholder="Select store"
                                options={storeOptions}
                                filterOption={(input, option) =>
                                    (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            name="price"
                            label="Price"
                            rules={[{ required: true, message: 'Please enter price' }]}
                        >
                            <Input
                                placeholder="Enter price"
                                type="number"
                                min={0}
                                step={0.01}
                            />
                        </Form.Item>
                    </Form>
                </Modal>

                {/* EDIT MODAL */}
                <Modal
                    title="Edit Discount"
                    open={editModalVisible}
                    onOk={handleEdit}
                    onCancel={handleEditCancel}
                    confirmLoading={loading}
                    width={600}
                    className="dark-modal"
                    footer={[
                        <Button key="cancel" onClick={handleEditCancel} className="yellow-btn-outline">Cancel</Button>,
                        <Button key="submit" type="primary" loading={loading} onClick={handleEdit} className="yellow-btn">Save</Button>,
                    ]}
                >
                    <Form
                        form={editForm}
                        layout="vertical"
                    >
                        <Form.Item
                            name="store_id"
                            label="Store ID"
                        >
                            <Input readOnly />
                        </Form.Item>
                        <Form.Item label="Store Name">
                            <Input value={selectedRecord?.store_name || ''} readOnly />
                        </Form.Item>
                        <Form.Item
                            name="price"
                            label="Price"
                            rules={[{ required: true, message: 'Please enter price' }]}
                        >
                            <Input
                                placeholder="Enter price"
                                type="number"
                                min={0}
                                step={0.01}
                            />
                        </Form.Item>
                    </Form>
                </Modal>

                {/* DELETE MODAL */}
                <Modal
                    title="Confirm discount deletion"
                    open={deleteModalVisible}
                    onOk={handleDelete}
                    onCancel={handleDeleteCancel}
                    confirmLoading={loading}
                    okText="Delete"
                    cancelText="Cancel"
                    okButtonProps={{ danger: true, className: "yellow-btn" }}
                    cancelButtonProps={{ className: "yellow-btn-outline" }}
                    className="dark-modal"
                >
                    {selectedRecord && (
                        <p>Are you sure you want to delete the discount for "{selectedRecord.store_name}"?</p>
                    )}
                </Modal>
            </Layout>
        </>
    )
}

export default ListDiscount 